import {
  SavePlanVersion_Input,
  useSavePlanVersionMutation,
  useSelectPlanVersionFieldQuery
} from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery(id: string) {
  const tuple = useSelectPlanVersionFieldQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.plan?.versions.map((node) => ({
        id: node.id,
        name: node.id,
        displayName: node.name
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}

export function useSavePlanVersion() {
  const [
    fnMutate,
    tuple
  ] = useSavePlanVersionMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: SavePlanVersion_Input) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
